import { useCallback, useState } from 'react';
import { httpsCallable } from 'firebase/functions';

import { functions } from '../utils/firebase';

const MARK_BREWERY_REVIEWS_SEEN = 'callableReviewMarkBreweryReviewsSeen-markBreweryReviewsSeen';

export function useMarkBreweryReviewsSeen() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = useCallback(async ({ breweryId, items }) => {
    setLoading(true);
    setError(null);
    try {
      const callable = httpsCallable(functions, MARK_BREWERY_REVIEWS_SEEN);
      const result = await callable({ breweryId, items });
      return result.data;
    } catch (mutationError) {
      setError(mutationError);
      throw mutationError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { mutate, loading, error };
}

export default useMarkBreweryReviewsSeen;
